import 'react-responsive-carousel/lib/styles/carousel.min.css';
import React from 'react';

import { Carousel } from 'react-responsive-carousel';

import { ImageContainer } from './styles';
import stylesMaterial from './stylesMaterial';

interface CustomCarouselProps {
  images: string[];
  paddingTop?: string;
}

export const CustomCarousel: React.FC<CustomCarouselProps> = (props) => {
  const { images, paddingTop } = props;

  const classes = stylesMaterial();

  return (
    <Carousel
      showThumbs={false}
      showStatus={false}
      className={classes.carouselRoot}
      autoPlay
      infiniteLoop
      interval={5000}
    >
      {images.map((image, index) => {
        return (
          <ImageContainer key={index} paddingTop={paddingTop}>
            <img src={image} alt="Banner" />
          </ImageContainer>
        );
      })}
    </Carousel>
  );
};
